import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare } from '@fortawesome/pro-light-svg-icons'

import {
  Box,
  Button,
  Columns,
  LoadingModule,
  PageHeader,
  Tools,
} from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import useAdCopies from '@hooks/useAdCopies'
import useCampaign from '@hooks/useCampaign'
import useCampaignSelector from '@hooks/useCampaignSelector'
import useCurrentUser from '@hooks/useCurrentUser'

import adCopyTypes from '@functions/adCopy'

import generateMediaAndCopyTabBarItems from '@sections/Client/packs/Campaign/utils/generateMediaAndCopyTabBarItems'

import { getCampaignPermissions, getCampaignType } from 'shared/functions/campaign'
import AdCopyItem from '../AdCopyItem'
import ProjectAdCopies from '../ProjectAdCopies'
import useCampaignSync from '../../hooks/useCampaignSync'

const PageContent = () => {
  const { campaignId: campaign_id } = useNumericParams()

  const { currentUser } = useCurrentUser()

  useCampaignSync(campaign_id)

  const adCopiesPayload = useAdCopies({
    filters: { campaign_id },
    performHttpRequests: !!campaign_id,
  })

  const { filteredAdCopies, loading } = adCopiesPayload

  const { campaign: { address } } = useCampaignSelector()

  const campaignPayload = useCampaign({ id: campaign_id })
  const { callbacks: { copyAdCopyLink }, campaign } = campaignPayload

  const permissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Ad Copy</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="adcopy"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={generateMediaAndCopyTabBarItems(campaign_id, permissions)}
        title="Ad Copy"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.campaign.adCopy.banner" />

            <LoadingModule loading={loading} times={3} />

            <ProjectAdCopies campaignId={campaign_id} />

            {!loading && adCopyTypes.map((adCopyType) => {
              const { key, title } = adCopyType
              const adCopy = filteredAdCopies.find(a => a.copy_type === key) || {
                campaign_id,
                copy_type: key,
              }

              // @ts-expect-error TS2322
              return <AdCopyItem adCopy={adCopy} key={key} title={title} />
            })}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.campaign.adCopy.sidebar" />

            <Tools>
              <Button
                buttonStyle="secondaryUtility"
                icon={<FontAwesomeIcon icon={faShare} />}
                onClick={() => copyAdCopyLink()}
                size="medium"
              >
                Share
              </Button>
            </Tools>
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
